import React, { useState } from "react";
import SectionContainer from "../../SectionContainer/SectionContainer";
import "./sectionTwo.css";
import IconHeader from "./IconHeader";
import CharacterGifImage from "../../../images/two-composite_char.gif";
import EffectGifImage from "../../../images/effects.gif";
import FilterGifImage from "../../../images/filters.gif";

const SectionTwo = () => {
  const [product, setProduct] = useState("character");

  const openPlayStore = () => {
    const url =
      "https://play.google.com/store/apps/details?id=com.kk.tweencraft";
    window.open(url, "_blank");
  };

  const getGifs = (product) => {
    if (product === "character") {
      return (
        <img src={CharacterGifImage} className="two-gif" alt="failed to load" />
      );
    } else if (product === "effects") {
      return (
        <img src={EffectGifImage} className="two-gif" alt="failed to load" />
      );
    } else if (product === "filter") {
      return (
        <img src={FilterGifImage} className="two-gif" alt="failed to load" />
      );
    }
  };

  const getProductTagLine = (product) => {
    if (product === "character") {
      return (
        <p>
          Select from our amazing character library or create your own
          characters.
        </p>
      );
    } else if (product === "effects") {
      return (
        <p>
          Add effects as you like and personalize them with our preset effect
          lab and layout.
        </p>
      );
    } else if (product === "filter") {
      return <p>Hype up your stories with insanely cool filters.</p>;
    }
  };

  return (
    <SectionContainer whiteBG={false}>
      <div className="two-container">
        <IconHeader product={product} setProduct={setProduct} />
        {getGifs(product)}
      </div>
      <div className="two-para-container">{getProductTagLine(product)}</div>
      <div className="two-explore" onClick={openPlayStore}>
        Explore all features
      </div>
    </SectionContainer>
  );
};

export default SectionTwo;
